module.exports = __webpack_public_path__ + "static/img/qtcj06.cd4537c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qtcj06.png
// module id = 466
// module chunks = 0